/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import Vue from 'vue';
import Component from 'vue-class-component';
import OrdersApi from '@/api/ordersV2';
import TabBar from '@/components/apply-tabs/index.vue';
import platform from '@/shared/utils/platform';
import RouterHelper from '@/shared/utils/routerHelper';
import router from '@/router';

import { Toast, Empty } from '@hb/coffee';
import { OrderStatusV2Enum, OrderStatusV2EnumToLabel, OrderTypeEnum } from '@/enums/orderV2';
import { PeriodTypeValue } from '@/enums/period-type';
import { OrderV2Po } from '@/po/orderV2';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';
import store from '@/store';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import ContractPreviewApi from '@/api/payOff-Certificate';
import SendEmailDialog from '@/components/email-dialog/index.vue';
import { ContractScene } from '@/api/payOff-Certificate/enum';
import { SuperMemberSceneEnum, SuperCardSummaryBackType, PackageBuyStatusEnum } from '@/api/rights/types';
import { getSuperMemberCardSummary } from '@/api/rights/index';
import { ubtSendError } from '@/shared/utils/ubt';
import ApplyItem = OrderV2Po.ApplyItem;

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const SuperMemberCard = () => import(
  /* webpackChunkName: "SuperMemberCard" */'./super-mebmer/index.vue'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

const style = require('./index.module.scss');

@Component({ name: 'MyApply' })
export default class MyApply extends Vue {
  private tabs = [
    { label: '全部' },
    { label: '提现申请中' },
    { label: '提现失败' },
    { label: '待还款' },
    { label: '已还清' },
  ];

  private orderTypeTitleMap = {
    [OrderTypeEnum.NORMAL]: '',
    [OrderTypeEnum.POCKET_MONEY]: '零用钱订单',
  };

  private orders: OrderV2Po.ApplyItem[] = [];

  private selectedIndex = parseInt(`${router.currentRoute.query.index}`, 10) || 0;

  private ready = false;

  /** 显示弹窗 */
  private sendEmailDialogShow = false;

  /** 当前选中的结清证明订单id */
  private currentCertificateloanOrderId = '';

  private SuperMemberSummary : SuperCardSummaryBackType = {};

  private async getSuperMemberCard() {
    try {
      this.SuperMemberSummary = await getSuperMemberCardSummary({
        sceneType: SuperMemberSceneEnum.LOAN_ORDER_LIST,
      });
    } catch {
      this.SuperMemberSummary = {};
      ubtSendError({ name: 'get_right_data_error', message: String(SuperMemberSceneEnum.LOAN_ORDER_LIST) });
    }
  }

  private async created() {
    window.scrollTo(0, 0);

    if (this.$route.query.from === 'home') {
      RouterHelper.setBackPath(RouterV2Enum.home);
    }

    this.orders = await OrdersApi.getOrderList();

    if (this.orders) {
      /** 请求会员概要接口 */
      this.getSuperMemberCard();
      this.ready = true;
    }

    this.orders = this.orders.filter(
      (order) => +order.productId !== 2040 && order.state !== OrderStatusV2Enum.BOUND,
    ); // 去掉杭银
  }

  private onSelectedChange(index: number) {
    this.selectedIndex = index;
  }

  private get filtedItem() {
    const index = this.selectedIndex;
    return index === 0
      ? this.orders.concat()
      : this.orders.filter(
        (item: ApplyItem) => this.statusToIndex(item.state) === index,
      );
  }

  private statusToIndex(status: OrderStatusV2Enum): number {
    if (status === OrderStatusV2Enum.LEND_FAILED) {
      return 2;
    }
    if (status === OrderStatusV2Enum.LENT) {
      return 3;
    }
    if (status === OrderStatusV2Enum.PAYOFF) {
      return 4;
    }
    return 1;
  }

  // 获取订单状态是否为LENT&PAYOFF状态,该状态下借款金额取实际借款金额
  private getOrderStatus(status: OrderStatusV2Enum): boolean {
    if (status === OrderStatusV2Enum.LENT || status === OrderStatusV2Enum.PAYOFF) {
      return true;
    }
    return false;
  }


  /** 跳转到结清证明页 */
  private async goPayOffCertificate(loanOrderId: string, event: Event) {
    event.stopPropagation();
    /** 微信小程序不支持查看"结清证明" */
    if (platform.isWechatMini) {
      jumpToNewVersion(NewVersionEnum.MINI_PROGRAMS_PROMPT, false);
      return;
    }

    this.currentCertificateloanOrderId = loanOrderId;
    const result = await ContractPreviewApi.getContractPreviewDetail(
      ContractScene.APPLY, loanOrderId,
    );
    // 如果有进行中的申请就展示已申请的提示
    if (result.pending === true) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('您的结清证明申请正在审核中，请稍后再试');
    } else {
      // 如果有预览链接就跳转到预览页
      if (result.url) {
        this.$ubtPageButton('finance_loan_payoffCertificate');
        jumpToNewVersion(NewVersionEnum.CONTRACT_PREVIEW, false, `loanOrderId=${loanOrderId}`);
      } else {
        // 没有预览链接就弹邮箱收集弹窗
        this.showSendEmailDialog();
      }
    }
  }

  private goBill(item: ApplyItem) {
    // 待还款
    this.$ubtPageButton(
      '臻有钱_我的提现_去还款',
      '产品',
      String(item.productId),
      'current', `${store.state.base.repayState.current}`,
      'overDue', `${store.state.base.repayState.overDue}`,
    );

    if (item.productId === '2000') {
      this.goNiWodai(item);
    } else {
      this.$router.push({
        path: RouterV2Enum.applyDetails,
        query: {
          loanId: item.loanOrderId,
          commodityId: String(item.productId),
        },
      });
    }
  }

  private goNiWodai(item: ApplyItem) {
    if (platform.isHelloApp) {
      // 你我贷2000 特殊处理
      this.$router.push(`/order-detail/${item.loanOrderId}`);
    } else {
      // 去下载app
      this.$router.push(`${RouterH5Enum.redirectApp}`);
    }
  }

  private getState(item: ApplyItem) {
    const status = item.state;
    const label = OrderStatusV2EnumToLabel[status] || '';

    switch (status) {
      case OrderStatusV2Enum.LEND_FAILED:
        return <span style="color:#ff0000;">{label} &gt;</span>;

      case OrderStatusV2Enum.LENT:
        return <span style="color:#FF5600;">待还款 &gt;</span>;

      case OrderStatusV2Enum.PAYOFF:
        return <span style="color:#000000;">{label}</span>;

      default:
        return <span style="color:#FF5600;">{label}</span>;
    }
  }

  private formatTime(time: string) {
    return time.replace('T', ' ').slice(0, 16);
  }

  private refreshSuperMember() {
    /** 此处重新调用接口的意义是 保证用户进入详情页购买超级会员后回退 页面状态更新 */
    this.getSuperMemberCard();
  }

  private renderNoItem() {
    /** 无订单时 若超级会员概要接口为未购买状态 加载超级会员卡组件 */
    if (this.SuperMemberSummary?.packageBuyStatus === PackageBuyStatusEnum.NOT_BUY) {
      return (
        <SuperMemberCard
          superMemberCardSummary={this.SuperMemberSummary}
          onRefreshSuperMember = {this.refreshSuperMember.bind(this)}
        />
      );
    }
    return (
      <Empty
        type="list"
        title="您还没有该状态的申请记录哦～"
        button-text="回到首页"
        onClick={() => {
          RouterHelper.backHome();
        }}
      />
    );
  }

  /** 显示dialog */
  private showSendEmailDialog() {
    this.sendEmailDialogShow = true;
    this.$ubtModuleExpose('finance_loan_payoffCertificate_sendEmailPopup');
  }

  /** 关闭dialog */
  private closeSendEmailDialog() {
    this.sendEmailDialogShow = false;
    this.currentCertificateloanOrderId = '';
  }

  private render() {
    return (
      this.ready && (
        <div class={style.MyApply}>
          <div class={style.tab}>
            <TabBar
              scrollable={true}
              listDatas={this.tabs}
              activeIndex={this.selectedIndex}
              onSelectedChange={this.onSelectedChange.bind(this)}
            />
          </div>
          <div class={style.myMain}>
            <div class={style.list}>
              {this.filtedItem.length > 0
                ? this.filtedItem.map((item: OrderV2Po.ApplyItem) => (
                  <div class={style.item} onclick={() => this.goBill(item)}>
                    <div class={style.block}>
                      <img class={style.icon} src={item.productUrl} />
                      {/* src={require('./img/icon.png')}/> */}
                      <div class={style.blockRight}>
                        <div class={style.title}>
                          {item.productName}
                          {this.orderTypeTitleMap[item.orderType] && (
                            <span class={style.orderType}>
                              {this.orderTypeTitleMap[item.orderType]}
                            </span>
                          )}
                        </div>
                        <div class={style.blockDetail}>
                          {this.getOrderStatus(item.state) ? (
                            <div class={style.blockDetailContent}>
                              借款金额:{' '}
                              <span class={style.blockDetailValue}>
                                {item.amount}元
                              </span>
                            </div>
                          ) : (
                          <div class={style.blockDetailContent}>
                            提现金额:{' '}
                            <span class={style.blockDetailValue}>
                              {item.applyAmount}元
                            </span>
                           </div>)
                        }
                          <span class={style.blockSep}></span>
                          <div class={style.blockDetailContent}>
                            期限{' '}
                            <span class={style.blockDetailValue}>
                              {item.applyPeriod}
                              {PeriodTypeValue(item.applyPeriodUnit)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class={style.line} />
                    <div class={style.itemBar}>
                      <div class={style.left}>
                        申请时间：{this.formatTime(item.applyTime)}
                      </div>
                      <div class={style.rightItem}>
                        {
                          item.payOffCertificate === true && <div class={style.rightItem}
                            onclick={this.goPayOffCertificate.bind(this, item.loanOrderId)}>
                            <img class={style.previewIcon} src={require('./img/certificate.png')} />
                            <span class={style.certificate}>结清证明</span>
                            <span class={style.previewLine} />
                          </div>
                        }
                        {this.getState(item)}</div>
                    </div>
                  </div>
                ))
                : this.renderNoItem()}
            </div>
            <SendEmailDialog
              show={this.sendEmailDialogShow}
              loanOrderId={this.currentCertificateloanOrderId}
              onClose={this.closeSendEmailDialog.bind(this)}
            />
          </div>
        </div>
      )
    );
  }
}
